module.exports = __webpack_public_path__ + "fonts/sourcesansprobolditalic.c364f601.ttf";